import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Jumlah Langkah Berjalan Harian untuk Menurunkan Berat Badan dengan Akurat";
const DESCRIPTION = "Gunakan kalkulator ini untuk menentukan jumlah langkah yang harus Anda lakukan setiap hari untuk menurunkan berat badan dengan cara yang sehat dan aman, berdasarkan berat badan Anda saat ini dan target penurunan berat badan Anda. Ideal untuk pria dan wanita yang peduli dengan kebugaran fisik.";
const KEYWORDS = "jumlah langkah berjalan, menurunkan berat badan dengan berjalan, kalkulator langkah, langkah untuk membakar lemak, membakar kalori dengan berjalan, jadwal berjalan harian, diet dengan berjalan, manfaat berjalan harian";
const OG_URL = "https://do-calculate.com/calculator/id/walking-calories/";
function WalkingCalorieCalculator() {
  const [weight, setWeight] = useState("");
  const [sex, setSex] = useState("male");
  const [slope, setSlope] = useState("0");
  const [steps, setSteps] = useState("");
  const [distance, setDistance] = useState("");
  const [time, setTime] = useState({ hours: "", minutes: "" });
  const [speed, setSpeed] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const calculateCalories = () => {
    try {
      setError("");
      if (!weight) {
        throw new Error("Harap masukkan berat badan");
      }
      const weightKg = parseFloat(weight);
      const slopePercent = parseFloat(slope);
      const stepsCount = steps ? parseFloat(steps) : null;
      const distanceKm = distance ? parseFloat(distance) : null;
      const speedKmh = speed ? parseFloat(speed) : null;
      const hours = time.hours ? parseFloat(time.hours) : 0;
      const minutes = time.minutes ? parseFloat(time.minutes) : 0;
      if (weightKg <= 0) {
        throw new Error("Berat badan harus lebih besar dari nol");
      }
      let calculatedDistance = distanceKm;
      let calculatedTime = hours + (minutes / 60);
      let calculatedSpeed = speedKmh;
      if (stepsCount && !distanceKm) {
        calculatedDistance = stepsCount * 0.762 / 1000;
      }
      if (calculatedDistance && calculatedTime && !speedKmh) {
        calculatedSpeed = calculatedDistance / calculatedTime;
      } else if (calculatedDistance && speedKmh && !calculatedTime) {
        calculatedTime = calculatedDistance / speedKmh;
      } else if (speedKmh && calculatedTime && !calculatedDistance) {
        calculatedDistance = speedKmh * calculatedTime;
      }
      let met;
      if (calculatedSpeed) {
        if (calculatedSpeed < 3.2) met = 2.0;
        else if (calculatedSpeed < 4.8) met = 2.8;
        else if (calculatedSpeed < 6.4) met = 3.5;
        else met = 5.0;
        met += Math.abs(slopePercent) * 0.1;
        if (slopePercent > 0) met *= 1.2;
        if (slopePercent < 0) met *= 0.8;
      } else {
        met = 3.5;
      }
      const caloriesBurned = met * weightKg * calculatedTime;
      const weightLost = caloriesBurned / 7700;
      setResult({
        caloriesBurned: caloriesBurned.toFixed(2),
        weightLost: weightLost.toFixed(4),
        distance: calculatedDistance ? calculatedDistance.toFixed(2) : null,
        time: calculatedTime.toFixed(2),
        speed: calculatedSpeed ? calculatedSpeed.toFixed(2) : null
      });
    } catch (error) {
      setError(error.message);
    }
  };
  const resetCalculator = () => {
    setWeight("");
    setSex("male");
    setSlope("0");
    setSteps("");
    setDistance("");
    setTime({ hours: "", minutes: "" });
    setSpeed("");
    setResult(null);
    setError("");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  <strong>Kalkulator Jumlah Langkah Berjalan untuk Menurunkan Berat Badan</strong> membantu Anda mengetahui jumlah langkah yang diperlukan setiap hari untuk mencapai target penurunan berat badan dengan cara yang sehat.
                  Kalkulator ini didasarkan pada berat badan Anda, kecepatan berjalan, jarak tempuh, dan bahkan kemiringan permukaan untuk memberikan perkiraan akurat kalori yang terbakar.
                </p>
                <p>
                  Dengan alat ini, Anda dapat mengetahui jumlah langkah yang perlu dilakukan setiap hari untuk membakar lemak secara efektif, baik di treadmill maupun di luar ruangan.
                  Kalkulator ini dikembangkan berdasarkan data ilmiah yang sesuai untuk berbagai usia dan berat badan, dan memberi Anda gambaran realistis tentang rencana berjalan yang ideal untuk Anda.
                </p>
                <p>
                  Kalkulator akan menghitung kalori yang terbakar dan berat badan yang hilang berdasarkan data ini.
                  Patuhi 150 menit aktivitas per minggu seperti yang direkomendasikan oleh otoritas kesehatan, dan mulailah hari ini perjalanan Anda menuju berat badan sehat dengan langkah sederhana dan terencana.
                </p>
                <div>
                  Sumber:
                  <ul>
                    <li>
                      <a href="https://pubmed.ncbi.nlm.nih.gov/13932993/" target="_blank" rel="noopener noreferrer"> Energy cost of running</a>
                    </li>
                    <li>
                      <a href="https://pubmed.ncbi.nlm.nih.gov/31141585/" target="_blank" rel="noopener noreferrer">  Association of Step Volume and Intensity With All-Cause Mortality in Older Women</a>
                    </li>
                  </ul>
                </div>
                <hr />
              </div>
              <br />
              <MobileUnderCalAds/>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="weight">
                        Berat Badan (kg)
                      </label>
                      <input
                        id="weight"
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        placeholder="Masukkan berat badan Anda"
                        className="form-control"
                        style={{ width: "75%" }}
                        min="1"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="sex">
                        Jenis Kelamin
                      </label>
                      <select
                        id="sex"
                        value={sex}
                        onChange={(e) => setSex(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="male">Laki-laki</option>
                        <option value="female">Perempuan</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="slope">
                        Kemiringan Permukaan Berjalan (%)
                      </label>
                      <input
                        id="slope"
                        type="number"
                        value={slope}
                        onChange={(e) => setSlope(e.target.value)}
                        placeholder="Masukkan persentase kemiringan"
                        className="form-control"
                        style={{ width: "75%" }}
                        min="-30"
                        max="30"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="steps">
                        Langkah
                      </label>
                      <input
                        id="steps"
                        type="number"
                        value={steps}
                        onChange={(e) => setSteps(e.target.value)}
                        placeholder="Masukkan jumlah langkah"
                        className="form-control"
                        style={{ width: "75%" }}
                        min="0"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Waktu Berjalan (jam:menit)
                      </label>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <input
                          type="number"
                          value={time.hours}
                          onChange={(e) => setTime({ ...time, hours: e.target.value })}
                          placeholder="Jam"
                          className="form-control"
                          style={{ width: '35%' }}
                          min="0"
                        />
                        <input
                          type="number"
                          value={time.minutes}
                          onChange={(e) => setTime({ ...time, minutes: e.target.value })}
                          placeholder="Menit"
                          className="form-control"
                          style={{ width: '35%' }}
                          min="0"
                          max="59"
                        />
                      </div>
                    </div>
                    <br />
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button
                        className="btn btn-success"
                        style={{ fontSize: "20px" }}
                        onClick={calculateCalories}
                      >
                        Hitung
                      </button>
                      <button
                        className="text-white bg-secondary"
                        style={{ fontSize: "20px" }}
                        onClick={resetCalculator}
                      >
                        Hapus
                      </button>
                    </div>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Kesalahan: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Hasil:</h4>
                      <p className="text-white">Kalori yang terbakar: {result.caloriesBurned} kalori</p>
                      <p className="text-white">Berat badan yang hilang: {result.weightLost} kg</p>
                      {result.distance && (
                        <p className="text-white">Jarak yang ditempuh: {result.distance} km</p>
                      )}
                      {result.speed && (
                        <p className="text-white">Kecepatan berjalan: {result.speed} km/jam</p>
                      )}
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Kalkulator Kalori Berjalan</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Manfaat Berjalan</h2>
                  </u>
                  <p>Berjalan adalah salah satu bentuk aktivitas fisik yang paling mudah tetapi paling diremehkan. Meskipun gagasan 10.000 langkah per hari mungkin berlebihan bagi sebagian orang, berjalan 7.000-8.000 langkah per hari memiliki banyak manfaat kesehatan!</p>
                  <ul>
                    <li>Menurut studi 2019, 4.400 langkah per hari dapat secara signifikan mengurangi angka kematian</li>
                    <li>Berjalan membantu mencegah penyakit kardiovaskular</li>
                    <li>Alat bantu utama dalam mengatasi diabetes</li>
                    <li>Mengurangi kecemasan dan meningkatkan kesehatan mental</li>
                    <li>Meningkatkan daya tahan dan kekuatan otot dalam jangka panjang</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info">
                    Berjalan 30 menit setiap hari dapat membakar sekitar 150-200 kalori!
                  </div>
                  <br />
                  <p>
                    Laporan NHS menyatakan bahwa berjalan dapat membantu Anda "membangun daya tahan, membakar kalori ekstra, dan membuat jantung Anda lebih sehat."
                    Namun, Anda tidak bisa hanya berjalan sebentar ke toko lokal Anda dan berharap menurunkan berat badan.
                    Jika membakar kalori adalah tujuan Anda, alat baru ini dapat membantu Anda memperkirakan jumlah langkah yang harus Anda ambil untuk menurunkan berat badan.
                  </p>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Cara Menggunakan Kalkulator</h2>
                  </u>
                  <p>Kalkulator kalori berjalan dari situs do-calculate membantu Anda memperkirakan kalori yang terbakar saat berjalan:</p>
                  <ol>
                    <li>Masukkan berat badan Anda saat ini</li>
                    <li>Masukkan kemiringan permukaan berjalan (positif untuk tanjakan, negatif untuk turunan)</li>
                    <li>Masukkan jarak tempuh, waktu, atau kecepatan rata-rata</li>
                  </ol>
                  <p>Kalkulator akan menghitung kalori yang terbakar dan berat badan yang hilang berdasarkan data ini.</p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Anda dapat menggunakan kalkulator ini untuk berjalan biasa atau di treadmill!
                  </div>
                  <br />
                  <p>
                    Berjalan sering diabaikan sebagai bentuk olahraga, namun jenis latihan yang mudah, gratis, dan berdampak rendah ini dapat membantu Anda menghilangkan beberapa kilogram.
                  </p>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Pertanyaan Umum</h2>
                  </u>
                  <p><b>Berapa banyak kalori yang terbakar dengan berjalan 10.000 langkah?</b></p>
                  <p>Rata-rata, pria membakar sekitar 500 kalori sementara wanita membakar sekitar 290 kalori.</p>
                  <p><b>Apakah perlu berjalan 10.000 langkah setiap hari?</b></p>
                  <p>Tidak, tetapi 7.500-8.000 langkah per hari memberikan manfaat kesehatan yang baik.</p>
                  <p><b>Apakah berjalan tanpa alas kaki memiliki manfaat kesehatan?</b></p>
                  <p>Ya, ini memperkuat otot kaki dan tungkai serta meningkatkan keseimbangan.</p>
                  <p><b>Berapa banyak kalori yang saya bakar saat berjalan selama satu jam?</b></p>
                  <p>Berkisar antara 200-500 kalori tergantung berat badan, kecepatan, dan kemiringan.</p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Ingat, berjalan kelompok dengan teman atau keluarga membuat aktivitas lebih menyenangkan!
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default WalkingCalorieCalculator;